import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from "react-router-dom";

import { MainLayout } from "@equipedigitalfloripa/ed-cms/layouts";

import IndexPage from "../pages/Index";
import NotFoundPage from "../pages/NotFound";

import ContentsPage from "../pages/Contents";
import EditContentPage from "../pages/EditContent";

import ArquivosPage from "../pages/Arquivos";
import EditArquivosPage from "../pages/EditArquivo";

import CategoriaArquivosPage from "../pages/CategoriasArquivos";
import EditCategoriaArquivosPage from "../pages/EditCategoriasArquivos";

import NoticiasPage from "../pages/Noticias";
import EditNoticiasPage from "../pages/EditNoticia";

import CategoriasPage from "../pages/Categorias";
import EditCategoriasPage from "../pages/EditCategorias";

import SliderPage from "../pages/Slider";
import EditSliderPage from "../pages/EditSlider";

import GestaoPage from "../pages/Gestao";
import EditGestaoPage from "../pages/EditGestao";

import ConveniosPage from "../pages/Convenios";
import EditConvenioPage from "../pages/EditConvenios";

import JuridicoPage from "../pages/Juridico";
import EditJuridicoPage from "../pages/EditJuridico";

import ColaboradorPage from "../pages/Colaborador";
import EditColaboradorPage from "../pages/EditColaborador";

import FiliadosPendentesPage from "../pages/FiliadosPendentes";
import EditFiliadosPendentesPage from "../pages/EditFiliadosPendentes";

import FiliadosPage from "../pages/Filiados";
import EditFiliadosPage from "../pages/EditFiliados";

import {
  Contatos,
  EditConfigPage,
  EditMetatagsPage,
  EditSocialMidiaPage,
  EditTranslationsPage,
  EditUserPage,
  TranslationsPage,
  UsersPage,
  ViewContatosPage,
} from "@equipedigitalfloripa/ed-cms/pages";

import {
  startFetchTranslations,
  startSetLang,
} from "@equipedigitalfloripa/ed-cms/actions";

import "@equipedigitalfloripa/ed-cms/layouts/main.css";
import "@equipedigitalfloripa/ed-cms/pages/main.css";
import "@equipedigitalfloripa/ed-cms/components/main.css";
import Disparos from "../pages/Disparos";

const SystemRouter = () => {
  const dispatch = useDispatch();
  const url =
    process.env.NODE_ENV === "production"
      ? process.env.REACT_APP_API_URL
      : "http://54.196.134.228:3000/";
  const full_url = url + "metatags/";
  const full_url_config = url + "config/";
  const full_url_socialmidia = url + "socialmidia/";
  const { loggedIn, user } = useSelector((state) => state.auth);
  const translations = useSelector(
    (state) => state.translations.translations.sidebar,
  );

  useEffect(() => {
    if (user && user.preferences) {
      dispatch(startSetLang(user.preferences.lang));
      dispatch(startFetchTranslations(process.env.REACT_APP_API_URL));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const navigation = [
    {
      title: "Arquivos",
      link: [
        {
          link: "/arquivos",
          title: "Arquivos",
        },
        {
          link: "/categoria_arquivos",
          title: "Categorias Arquivos",
        },
      ],
    },
    {
      title: translations.site_news,
      link: [
        {
          link: "/noticias",
          title: translations.site_news,
        },
        {
          link: "/categorias",
          title: translations.site_categories,
        },
      ],
    },

    {
      title: "Filiados",
      link: [
        {
          link: "/filiados",
          title: "Gerenciar Filiados",
        },
        {
          link: "/filiados-solicitacoes",
          title: "Gerenciar Solicitações",
        },
      ],
    },
    {
      link: "/sliders",
      title: "Sliders",
    },
    {
      link: "/gestao",
      title: "Gestões",
    },
    {
      link: "/colaborador",
      title: "Colaboradores",
    },
    {
      link: "/convenios",
      title: "Convênios",
    },
    {
      link: "/juridico",
      title: "Assessoria Jurídica",
    },
    {
      link: "/contents",
      title: translations.site_simple_content,
    },
    {
      link: "/disparos",
      title: "Disparos de Email para associados",
    },
  ];
  return loggedIn ? (
    <Router>
      <MainLayout navigation={navigation}>
        <Switch>
          <Route path="/disparos" component={Disparos} />

          <Route path="/" component={IndexPage} exact />

          <Route
            path="/edit/contents/:id"
            render={(props) => <EditContentPage {...props} edit={true} />}
          />
          <Route path="/add/contents" component={EditContentPage} />
          <Route path="/contents" component={ContentsPage} />

          <Route
            path="/edit/noticias/:id"
            render={(props) => <EditNoticiasPage {...props} edit={true} />}
          />
          <Route path="/add/noticias" component={EditNoticiasPage} />
          <Route path="/noticias" component={NoticiasPage} />

          <Route path="/arquivos" component={ArquivosPage} />
          <Route path="/add/arquivos" component={EditArquivosPage} />
          <Route
            path="/edit/arquivos/:id"
            render={(props) => <EditArquivosPage {...props} edit={true} />}
          />

          <Route path="/categoria_arquivos" component={CategoriaArquivosPage} />
          <Route
            path="/edit/categoria_arquivos/:id"
            render={(props) => (
              <EditCategoriaArquivosPage {...props} edit={true} />
            )}
          />
          <Route
            path="/add/categoria_arquivos"
            component={EditCategoriaArquivosPage}
          />

          <Route
            path="/filiados-solicitacoes"
            component={FiliadosPendentesPage}
          />
          <Route
            path="/edit/filiados-solicitacoes/:id"
            render={(props) => (
              <EditFiliadosPendentesPage {...props} edit={true} />
            )}
          />
          <Route
            path="/add/filiados-solicitacoes"
            component={EditFiliadosPendentesPage}
          />

          <Route path="/filiados" component={FiliadosPage} />
          <Route
            path="/edit/filiados/:id"
            render={(props) => <EditFiliadosPage {...props} edit={true} />}
          />
          <Route path="/add/filiados" component={EditFiliadosPage} />

          <Route path="/sliders" component={SliderPage} />
          <Route
            path="/edit/sliders/:id"
            render={(props) => <EditSliderPage {...props} edit={true} />}
          />
          <Route path="/add/sliders" component={EditSliderPage} />

          <Route
            path="/edit/categorias/:id"
            render={(props) => <EditCategoriasPage {...props} edit={true} />}
          />
          <Route path="/add/categorias" component={EditCategoriasPage} />
          <Route path="/categorias" component={CategoriasPage} />

          <Route
            path="/edit/gestao/:id"
            render={(props) => <EditGestaoPage {...props} edit={true} />}
          />
          <Route path="/add/gestao" component={EditGestaoPage} />
          <Route path="/gestao" component={GestaoPage} />

          <Route
            path="/edit/convenios/:id"
            render={(props) => <EditConvenioPage {...props} edit={true} />}
          />
          <Route path="/add/convenios" component={EditConvenioPage} />
          <Route path="/convenios" component={ConveniosPage} />

          <Route
            path="/edit/juridico/:id"
            render={(props) => <EditJuridicoPage {...props} edit={true} />}
          />
          <Route path="/add/juridico" component={EditJuridicoPage} />
          <Route path="/juridico" component={JuridicoPage} />

          <Route
            path="/edit/colaborador/:id"
            render={(props) => <EditColaboradorPage {...props} edit={true} />}
          />
          <Route path="/add/colaborador" component={EditColaboradorPage} />
          <Route path="/colaborador" component={ColaboradorPage} />

          <Route path="/edit/metatags">
            <EditMetatagsPage full_url={full_url} />
          </Route>
          <Route path="/edit/config">
            <EditConfigPage full_url={full_url_config} />
          </Route>
          <Route path="/edit/socialmidia">
            <EditSocialMidiaPage full_url={full_url_socialmidia} />
          </Route>

          <Route path="/edit/users/:id">
            <EditUserPage api_url={url} edit={true} />
          </Route>
          <Route path="/add/users">
            <EditUserPage api_url={url} />
          </Route>
          <Route path="/users">
            <UsersPage api_url={url} />
          </Route>

          <Route path="/edit/contatos/:id">
            <ViewContatosPage api_url={url} edit={true} />
          </Route>
          <Route path="/contatos">
            <Contatos api_url={url} />
          </Route>

          <Route path="/edit/translations/:id">
            <EditTranslationsPage api_url={url} />
          </Route>
          <Route path="/translations">
            <TranslationsPage api_url={url} />
          </Route>
          <Route component={NotFoundPage} />
        </Switch>
      </MainLayout>
    </Router>
  ) : (
    <Redirect to="/login" />
  );
};

export default SystemRouter;
